<template>
  <div class="lad-filter--month-content">
    <slot name="before-range" />

    <div class="wrapper-element-filter">
      <el-checkbox-group
        v-model="privateValues"
        :class="{ 'is-closed': !openItems }"
      >
        <el-checkbox
          v-for="[key, label] in Object.entries(months)"
          :key="key"
          :label="key"
          >{{ label }}</el-checkbox
        >
      </el-checkbox-group>

      <el-button type="text" @click="handleChange">{{
        $t(`general.${itemsText}`)
      }}</el-button>
    </div>

    <slot name="buttons" />
  </div>
</template>

<script>
export default {
  name: 'LadFilterMonth',
  props: {
    // eslint-disable-next-line vue/require-valid-default-prop
    values: { type: Array, default: [], required: true },
  },
  data() {
    return {
      base: 'filters',
      privateValues: [],
      limitMin: 6,
      openItems: false,
    }
  },
  computed: {
    itemsText() {
      return this.openItems ? 'show_less' : 'show_more'
    },
    months() {
      // Crear una lista del 0 al 23
      const list = Array.from({ length: 24 }, (_, i) => i)

      // Crear un objeto donde las claves sean los números y los valores sean los meses en formato texto
      const monthsMap = {}

      list.forEach((index) => {
        // Obtener la fecha actual y sumar el índice a meses
        const date = this.$dayjs().startOf('month').add(index, 'month')

        // Formatear la fecha como mes/año
        const formattedDate = date.format('MMMM YYYY')

        // Asignar al objeto
        monthsMap[index] = formattedDate
      })

      return monthsMap
    },
  },
  watch: {
    values: {
      immediate: true,
      handler(newValue, oldValue) {
        if (typeof oldValue === 'undefined') {
          /** se hace conversion solo la primera vez para evitar loop infinito */
          this.privateValues = this.convertToString(newValue)
        } else {
          this.privateValues = newValue
        }
      },
    },
    privateValues(newValue, oldValue) {
      if (typeof oldValue !== 'undefined') {
        this.$emit('update-values', newValue)
      }
    },
  },
  methods: {
    handleChange() {
      this.openItems = !this.openItems
    },
    convertToString(items) {
      return items.map((item) => {
        if (typeof item === 'string') {
          return item
        }

        return item.toString()
      })
    },
  },
}
</script>

<style lang="scss">
.lad-filter--month-content {
  width: auto;

  .wrapper-element-filter {
    max-height: 40vh;
    overflow-y: auto;
  }

  .el-checkbox {
    margin-right: 0;
    text-transform: capitalize;
    line-height: 1.8;
  }

  .el-checkbox-group {
    &.is-closed > .el-checkbox:nth-child(n + 6) {
      display: none;
    }
  }
}
</style>
